












import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';

const cssPrefix = 'sw-widget-body';

@Component({
  components: {
  },
})
export default class SwWidgetBody extends SwExtendedVue {
  cssPrefix = cssPrefix;

  @Prop({ type: Number, required: false, default: 60 })
  refreshRate: number;

  @Prop({ type: String, required: false })
  dataGroup: string;

  @Prop({ type: String, required: false })
  endpoint: string;

}
